import { IBaseRequestParams } from '../../../../store/types/Request.types';
import { IProduct } from '../../types/Product.types';
import { IBaseVerifiedAddress, IVerifiedAddress } from '../../types/Shipping.types';
import { TCountry } from '../../../../store/countries/countries.types';

export enum ShippingAddressField {
  Address = 'address',
  Address2 = 'address2',
  City = 'city',
  Country = 'country',
  State = 'state',
  Zipcode = 'zipcode',
  Phone = 'phone',
  Company = 'company',
}

export interface IShippingAddress {
  [ShippingAddressField.Address]: string;
  [ShippingAddressField.Address2]: string;
  [ShippingAddressField.City]: string;
  [ShippingAddressField.Country]: number;
  [ShippingAddressField.State]: string;
  [ShippingAddressField.Zipcode]: string;
  [ShippingAddressField.Phone]: string;
  [ShippingAddressField.Company]: string;
}

export interface IShippingValidation {
  address: IShippingAddress;
}

export interface IShippingParams extends IBaseRequestParams {
  product: IProduct | null;
  address: IShippingAddress;
}

export interface IShippingForm extends IShippingAddress {}

export interface IShippingFormFields extends Omit<IShippingForm, ShippingAddressField.Country> {
  [ShippingAddressField.Country]: TCountry;
}

export interface IAddressValidationResponse {
  address: IBaseVerifiedAddress | null;
  isAddressVerified: boolean;
  isAddressChanged: boolean;
}

export interface IVerifiedShippingValidation extends IShippingValidation {
  verifiedAddress: IVerifiedAddress | null;
  isAddressVerified: boolean;
  isAddressChanged: boolean;
}

export enum ShippingAddressFlow {
  shippingForm = 'shippingForm',
  addressSelectionForm = 'addressSelectionForm',
}

export enum AddressOption {
  none = 'none',
  original = 'original',
  verified = 'verified',
}

export interface IShippingAddressParams extends IBaseRequestParams {
  countryId: number;
}
